import profile from "../assets/me.jpg"
export const about = {
    avatar: profile,
    name: 'Sumaiya Meem',
    email: 'stmeem@yahoo.com',
    github: 'https://github.com/stmeem',
    linkedin: 'https://www.linkedin.com/in/sumaiyatasmeem/',
    dev: 'https://dev.to/stmeem',
    leetcode: 'https://leetcode.com/sumaiyatasmeem/',
    skills: [
        {
            id: 0,
            name: 'html'
        },
        {
            id: 1,
            name: 'css'
        },
        {
            id: 2,
            name: 'javascript'
        },
        {
            id: 3,
            name: 'responsive design'
        },
        {
            id: 4,
            name: 'bootstrap'
        },
        {
            id: 5,
            name: 'tailwind'
        },
        {
            id: 6,
            name: 'react'
        },
        {
            id: 7,
            name: 'laravel'
        },
        {
            id: 8,
            name: 'github'
        },
    ],
    bioIntro: "I'm Sumaiya Tasmeem.",
    bioPreface: "I have great enthusiasm for technology and software development. Currently I'm working on building web apps using Laravel and working up on polishing my skills in problem solving.",
    bioSub: '',
    bioMain: ''
}